import { Config } from "../../../../configurations/config";

export const GeneralReimbursementAPIs = {
  GetMealType: `${Config.server_url}${Config.api_prefix}/Reimbursement/GetMealTypes`,
  GetTravelType: `${Config.server_url}${Config.api_prefix}/Reimbursement/GetTravelTypes`,
  PostGeneralReimbursement: `${Config.server_url}${Config.api_prefix}/Reimbursement/General`,
  GetEmpInfo:`${Config.server_url}${Config.api_prefix}/Employee/GetEmployeeInfo`,
  UpdateGeneralReimbursementRecord:`${Config.server_url}${Config.api_prefix}/Reimbursement/General`,
  /*Finance department */
  ChangeReimbursementStatus:`${Config.server_url}${Config.api_prefix}/Reimbursement/General`
};